import { useMemo } from "react";
import { parseAsIsoDate, useQueryState } from "nuqs";

export const useWeekDate = () => {
  const [weekDate, setWeekDate] = useQueryState("week", parseAsIsoDate);

  const date = useMemo(() => weekDate ?? new Date(), [weekDate]);

  return {
    date,
    setWeekDate,
  };
};
